import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";

// !!!! ALSO CHANGE IN MINT ROOT
const REACT_APP_MINT_TIER_MX1_GENESIS_ID =
  "10f3b1e8-1e74-4a69-9892-39df602721de";
const REACT_APP_MINT_TIER_MX1_ART_ID = "80156c3a-df1b-45c7-859c-8ff6ef920806";

import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

const MintStartsSoon = ({ mintTierId }, context) => {
  return (
    <div
      className="shadow mb-3 bg-transparent border-0 mint-card"
      // style={{ opacity: maxMintAmount() <= 0 ? "0.7" : "1.0" }}
    >
      <div className="">
        <h2 className="text-uppercase fw-bold mb-3">
          {context.t("MX1 ART Collection")}
        </h2>
        <p className="fw-bold mb-5">
          {context.t("Minting starts Friday evening, 17. Februar.")}
        </p>
        <p className="mb-5">
          {context.t(
            "The Samsung MX1 ART COLLECTION includes 9 different artpieces of 4 well known artists form the segments fashion and 3-motion, photography and architecture and interior design.  Artists: Antoni Tudisco, Bruno Urli, Charlotte Taylor, Anthony Authié and Nico Chiara. 100% royalty fees will be provided to artists of the pieces."
          )}
        </p>
        <p className="h5 fw-bold mt-3 text-uppercase">
          {context.t("Mint starts soon")}
        </p>
        <div className="border-top border-bottom justify-content-start py-3">
          <p className="pb-3">
            {context.t(
              "If you ordered the limited Samsung x Ledger web3 starter bundle or the Samsung Galaxy S23 between 01. Feb - 17. Feb 2023 via Amazon you will receive a unique mint voucher code."
            )}
          </p>
          <p className="mb-0">
            {context.t(
              "Use this code to claim your Samsung MX1 ART Collection NFT of your favorite Artist."
            )}
          </p>
        </div>

        <Row className="d-flex justify-content-between mt-5 align-items-center">
          <Col xs={12} md={7}>
            <p className="pb-0 mb-0">
              {context.t(
                "You want to bookmark upcoming Samsung mints? Add them to your calendar here."
              )}
            </p>
          </Col>
          <Col xs={12} md={5} className="text-end">
            <a
              className="btn btn-primary btn-lg"
              download={(REACT_APP_CDN_PATH || "") + "/MX1_art_collection.ics"}
              href={(REACT_APP_CDN_PATH || "") + "/MX1_art_collection.ics"}
            >
              {context.t("Bookmark Mint Calendar")}
            </a>
          </Col>
        </Row>

        <Modal
        // isOpen={showVoucherCodeHint}
        // toggle={() => setShowVoucherCodeHint(false)}
        >
          <ModalHeader>{context.t("Where can I get my code?")}</ModalHeader>
          <ModalBody>
            {mintTierId === REACT_APP_MINT_TIER_MX1_GENESIS_ID && (
              <>
                {context.t("This is how you obtain a MX1 Genesis Edition Code")}
              </>
            )}
            {mintTierId === REACT_APP_MINT_TIER_MX1_ART_ID && (
              <>
                {context.t("This is how you obtain a MX1 Art Collection Code")}
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
MintStartsSoon.contextTypes = {
  t: PropTypes.func,
};

MintStartsSoon.propTypes = {
  mintTierId: PropTypes.string,
  onSubmit: PropTypes.func,
};

MintStartsSoon.defaultProps = {};

export default MintStartsSoon;
